<template>
  <div>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <loading
      :active.sync="loading.app"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light">
      <div class="left">
        <router-link :to="{ name: 'account' }" class="headerButton">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </router-link>
      </div>
      <div class="pageTitle">PIN Keamanan</div>
    </div>
    <!-- * App Header -->

    <!-- App Capsule -->
    <div id="appCapsule" v-if="loading.app == false">
      <div class="section full mt-2">
        <ul class="listview image-listview inset">
          <li>
            <router-link
              :to="{
                name: 'account.pin.form',
                params: { back_reference: true },
              }"
              class="item"
            >
              <div class="in">
                <div>
                  Ubah PIN
                  <footer>
                    Amankan akun dengan melakukan perubahan secara berkala
                  </footer>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <div class="item">
              <div class="in">
                <div>
                  PIN Transaksi
                  <footer>
                    Gunakan PIN untuk kemanan Transaksi
                  </footer>
                </div>
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="pinTrx"
                    v-model="data.pin_trx"
                    @change="changeTogglePin"
                  />
                  <label class="custom-control-label" for="pinTrx"></label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import $axios from "./../../../api.js";
export default {
  name: "account.pin",
  props: ["toast_reference"],
  data() {
    return {
      data: {
        pin_trx: false,
      },
    };
  },
  created() {},

  computed: {
    ...mapState(["customer", "toast", "loading", "VUE_ENV"]),
  },
  methods: {
    ...mapActions(["getCustomer"]),
    changeTogglePin() {
      if (this.data.pin_trx) {
        // Jika pin trx di aktifkan
        $axios
          .post("/pin/toggle-trx/active", this.data)
          .then((response) => {
            // this.loading.app = false;
            this.$store.commit("SET_CUSTOMER", response.data.data);
            this.data.pin_trx =
              this.customer.pin_trx == "ENABLED" ? true : false;
            this.$store.commit("SET_TOAST", {
              show: true,
              message: response.data.message,
              tipe: "default",
              icon: "success",
            });
          })
          .catch((error) => {
            this.$store.commit("SET_TOAST", {
              show: true,
              message: error.response.data.message,
              tipe: "default",
              icon: "danger",
            });
            this.loading.app = false;
          });
      } else {
        // pin transaksi dimatikan
        this.$router.push({
          name: "auth.pin.verify",
          params: {
            data_reference: this.data,
            url_reference: "/pin/toggle-trx/inactive",
            previous_page_reference: "account.pin",
            next_page_reference: "account.pin",
          },
        });
      }
    },
  },
  mounted() {
    this.getCustomer().then(() => {
      this.data.pin_trx = this.customer.pin_trx == "ENABLED" ? true : false;
    });
    setTimeout(() => {
      if (this.toast_reference != undefined) {
        this.$store.commit("SET_TOAST", this.toast_reference);
      }
      this.$store.commit("SET_LOADING", { app: false });
    }, 500);
  },
  destroyed() {
    this.$store.commit("RESET_LOADING");
    this.$store.commit("RESET_TOAST");
  },
};
</script>
